import styled, { css } from 'styled-components';
import { device } from '../../../styles/devices';
import { COLORS, SIZING } from '../../../styles/variables';

export const Header = styled.div`
  display: flex;
  gap: 4px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;

export const ButtonContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 0 24px 0;
  @media ${device.laptop} {
    padding: 24px;
    justify-content: flex-start;
    border-top: 1px solid ${COLORS.grey15};
  }
  color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.black)};
`;

export const LocationButton = styled.button<{ isLaptop: boolean; disabled?: boolean }>`
  border: none;
  background-color: unset;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.black)};
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media ${device.laptop} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LocationText = styled.div<{ disabled?: boolean }>`
  margin-top: 4px;
  padding-left: 8px;
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.003px;
  color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.black)};
  text-decoration: underline;
  text-align: left;
  text-decoration-color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.grey60)};
  text-underline-position: under;
  text-underline-offset: 2px;

  @media ${device.laptop} {
    padding-left: 28px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`;
